import React, { useState } from 'react';
import {
  Dialog, DialogContent, Typography, Button, Link, DialogTitle, DialogActions,
} from '@mui/material';
import Logo from '../../images/logo1.1.png';

function DialogIfExistsPond(props) {
  const [open, setOpen] = useState(true);

  return (
    <Dialog open={open}>
      <DialogContent>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h5" component="span" style={{ fontWeight: 'bold' }}>{props.message}</Typography>
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary" size="large">
            Entendi
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default DialogIfExistsPond;
